export default __webpack_public_path__ + "static/media/merge-field-placeholder.c023dc21.svg";